import { TransportType } from 'src/types/transport';

export const formatData = (transport: TransportType): TransportType => {
    return {
        ...transport,
        TRACKING_NUMBER: transport.TRACKING_NUMBER,
    };
};
